<template>
  <div>
    <v-card>
      <v-dialog
        v-model="dialog"
        persistent
        scrollable
        max-width="500"
        :fullscreen="$vuetify.breakpoint.xsOnly"
      >
        <v-card>
          <v-toolbar max-height="64">
            <v-toolbar-title>
              {{ currentProvider.text }}
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn :disabled="loading" icon @click="dialog = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar>

          <v-card-text style="height: auto" class="pa-2">
            <div v-if="depositMethods.length != 0">
              <v-subheader class="overline pt-4">
                {{ $t("deposit") }}
              </v-subheader>
              <div class="pa-4 px-6">
                <div
                  v-for="item in depositMethods"
                  :key="`${item.id_metodo}-${item.fluxo}`"
                  class="d-flex row align-center"
                >
                  <v-switch
                    v-model="item.method_status"
                    :label="item.nome_metodo"
                    class="px-2"
                  >
                  </v-switch>
                  <div />
                </div>
              </div>
            </div>
            <div v-if="withdrawMethods.length != 0">
              <v-subheader class="overline pt-4">
                {{ $t("withdraw") }}
              </v-subheader>
              <div class="pa-4 px-6">
                <div
                  v-for="item in withdrawMethods"
                  :key="`${item.id_metodo}-${item.fluxo}`"
                  class="d-flex row align-center"
                >
                  <v-switch
                    v-model="item.method_status"
                    :label="item.nome_metodo"
                    class="px-2"
                    :disabled="shouldDisablePaybrokersWithdraw(item)"
                  >
                  </v-switch>
                  <div v-if="shouldDisablePaybrokersWithdraw(item)">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon
                          v-on="on"
                          v-bind="attrs"
                          class="mb-1 ml-2"
                          color="primary"
                        >
                          mdi-information-outline
                        </v-icon>
                      </template>
                      <span>
                        {{ $t("cantDeactivatePaybrokers") }}
                      </span>
                    </v-tooltip>
                  </div>
                </div>
              </div>
            </div>
            <v-card-actions class="pa-4">
              <v-spacer></v-spacer>
              <v-btn
                :loading="loading"
                color="primary"
                type="submit"
                @click="updateMethods"
              >
                {{ $t("toSave") }}
              </v-btn>
            </v-card-actions>
          </v-card-text>
          <v-divider></v-divider>
        </v-card>
      </v-dialog>
      <div class="pt-4">
        <p class="text-h5 pl-4">
          {{ $t("paymentProviders") }}
        </p>
      </div>
      <v-card-text>
        <v-data-table :items="payment" :headers="paymentProvidersHeaders">
          <template v-slot:item.actions="{ item }">
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-bind="attrs"
                  v-on="on"
                  small
                  @click="seeMethods(item)"
                  :disabled="loadingMethods"
                  :loading="gatewayIdBeingOpened === item.id"
                >
                  <v-icon>mdi-eye</v-icon>
                </v-btn>
              </template>
              <span>{{ $t("seeMethods") }}</span>
            </v-tooltip>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
  </div>
</template>
<script>
export default {
  name: "",
  components: {},
  data: (_this) => ({
    loading: false,
    dialog: false,
    confirmMethodStatusChangeDialog: false,
    currentProvider: {
      text: "",
    },
    methods: [],
    currentMethod: {
      id_metodo: "",
      id_gateway: "",
      method_status: "",
    },
    methodsHeaders: [
      { text: "ID", value: "id_metodo" },
      { text: _this.$t("name"), value: "nome_metodo" },
      { text: _this.$t("status"), value: "method_status" },
      { text: _this.$t("action"), value: "actions" },
    ],
    paymentProvidersHeaders: [
      { text: "ID", value: "id_gateway" },
      { text: _this.$t("name"), value: "text" },
      { text: _this.$t("action"), value: "actions" },
    ],
    payment: [],
    depositMethods: [],
    withdrawMethods: [],
    currentPaymentMethods: [],
    loadingMethods: false,
    gatewayIdBeingOpened: 0,
  }),

  created() {
    this.payment = this.paymentProviders;

    this.fetchPaymentMethods();
  },

  watch: {
    paymentProviders(val) {
      if (val.length > 0) {
        this.payment = val;
      }
    },
  },

  computed: {
    verifyBank() {
      return this.$store.state.operator.verify_bank;
    },
    paymentProviders() {
      if (Array.isArray(this.$store.state.operator.payment_providers)) {
        return this.$store.state.operator.payment_providers.filter(
          ({ value }) => value !== "manual"
        );
      }

      return [];
    },
    paymentMethods() {
      return this.$store.state.operator.payment_methods;
    },
  },

  methods: {
    async fetchPaymentMethods() {
      const response = await this.$axios.get(
        "/administrator/bankOnline/listPaymentMethods"
      );

      this.currentPaymentMethods = response.data.dados;
      this.$store.commit("setVerifyBank", response.data.verify_bank);
    },
    shouldDisablePaybrokersWithdraw(item) {
      if (this.verifyBank == "1") {
        if (
          item.id_metodo == "1" &&
          item.method_status &&
          item.fluxo == "2" &&
          item.id_gateway == "1"
        ) {
          return true;
        }
      }

      return false;
    },
    async seeMethods(item) {
      this.gatewayIdBeingOpened = item.id;

      this.loadingMethods = true;

      await this.fetchPaymentMethods();

      this.currentProvider = item;

      let depositMethods = [];
      let withdrawMethods = [];

      this.paymentMethods
        .filter((provider) => provider.id_gateway == item.id)
        .forEach((method) => {
          if (method.fluxo == "1") {
            let currentMethod = this.currentPaymentMethods.find(
              (item) =>
                item.fluxo == "1" &&
                method.id_metodo == item.id_metodo &&
                method.id_gateway == item.id_gateway
            );

            depositMethods.push({
              ...currentMethod,
              method_status: currentMethod.method_status == "1",
            });
          } else if (method.fluxo == "2") {
            let currentMethod = this.currentPaymentMethods.find(
              (item) =>
                item.fluxo == "2" &&
                method.id_metodo == item.id_metodo &&
                method.id_gateway == item.id_gateway
            );

            withdrawMethods.push({
              ...currentMethod,
              method_status: currentMethod.method_status == "1",
            });
          }
        });

      this.depositMethods = depositMethods;
      this.withdrawMethods = withdrawMethods;

      this.loadingMethods = false;
      this.dialog = true;
      this.gatewayIdBeingOpened = 0;
    },
    updateMethods() {
      this.loading = true;

      const methods = [...this.depositMethods, ...this.withdrawMethods].map(
        (method) => ({
          status: method.method_status ? "1" : "0",
          id_metodo: method.id_metodo,
          id_gateway: method.id_gateway,
          fluxo: method.fluxo,
        })
      );

      const formdata = new FormData();
      formdata.append("methods", JSON.stringify(methods));

      this.$axios
        .post(
          "/administrator/bankOnline/updateOperatorPaymentMethods",
          formdata
        )
        .then((res) => {
          this.fetchPaymentMethods();

          this.$store.commit("setFeedbackSnack", {
            msg: res.data.messages,
            color: "success",
          });

          const methods = this.paymentMethods;

          res.data.dados.forEach((method) => {
            for (let item of methods) {
              if (
                item.id_metodo == method.id_metodo &&
                item.id_gateway == method.id_gateway &&
                item.fluxo == method.fluxo
              ) {
                item.method_status = item.method_status == "0" ? "1" : "0";
              }
            }
          });

          this.$store.commit("setOperatorPaymentMethods", methods);
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>
